import React, { useState, useEffect } from "react";
import Courses from "./components/Courses";
import "./departments.css";
import Loader from "../../../components/Loader";
import { API_BASE_URL, authFetch } from "../../../config/api";
import { useNavigate } from "react-router-dom";

function Departments() {
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [currentSession, setCurrentSession] = useState(null);
  const [otherSessions, setOtherSessions] = useState([]);

  useEffect(() => {
    setLoad(true);
    authFetch(`${API_BASE_URL}/api/sessions/`)
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          setCurrentSession(json.sessions.find((s) => s.current) || null);
          setOtherSessions(json.sessions.filter((s) => !s.current));
        }
      })
      .catch(console.error)
      .finally(() => setLoad(false));
  }, []);

  return (
    <div className="fc_page">
      <div className="fc_header">
        <div>
          <p className="fc_overline">Academic Tools</p>
          <h2>Faculty Courses</h2>
          <p className="fc_subtitle">Browse departments and their courses by session.</p>
        </div>
      </div>

      {load && <Loader />}

      {currentSession && (
        <div className="fc_section">
          <div className="fc_section_head">
            <span className="fc_section_label">Current Session</span>
            <span className="fc_session_badge">{currentSession.session}</span>
          </div>
          <Courses session={currentSession.session} />
        </div>
      )}

      {otherSessions.length > 0 && (
        <div className="fc_section">
          <div className="fc_section_head">
            <span className="fc_section_label">Other Sessions</span>
          </div>
          <div className="fc_session_list">
            {otherSessions.map((s) => (
              <button
                key={s.session}
                className="fc_session_chip"
                onClick={() => navigate(`/admin/faculty/courses/${s.session}`)}
              >
                {s.session}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Departments;
